module.exports = __webpack_public_path__ + "img/SKWINKELNetActieActieplanningCA526C.40753c52.png";